// extracted by mini-css-extract-plugin
export var closed = "_h7-1";
export var resizer = "_h7-0";